import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icons from '../../../helpers/Icons';
import './ConversationsIcon.scss';

const ConversationsIcon = ({ linkTo, count, }) => {
  const chatIcon = (linkTo ? <Link to={linkTo}>{Icons('chat')}</Link> : Icons('chat'));
  return (
    <div className="conversations-notifications">
      {chatIcon}
      <span className="conversations-counter">{count}</span>
    </div>
  );
};

ConversationsIcon.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  linkTo: PropTypes.string,
};

ConversationsIcon.defaultProps = {
  linkTo: null,
  count: '',
};

export default ConversationsIcon;
